// Pestañas del módulo Gift Cards (F3 reorden 24-oct-2026): «Enviar» (la pantalla de siempre) y «Ajustes» (lo que era
// /dashboard/gift-card-config, que ya no tiene entrada propia en el menú). Compartido por las dos páginas y el wrapper de rutas.
import { Send, Settings } from 'lucide-react';
import type { PestanaModulo } from '../../components/common/PestanasModulo';

export const GIFT_TABS: PestanaModulo[] = [
  { id: 'enviar', label: 'Enviar', icon: Send },
  { id: 'ajustes', label: 'Ajustes', icon: Settings },
];
export const GIFT_TAB_IDS = GIFT_TABS.map((t) => t.id);
